<div class="modal-header">
  <wl-logo
    class="modal__logo"
    [id]="'cookiewall-logo'"
    [title]="brandName + ' logo'"
  />
</div>
<div class="modal-body">
  <div>
    <h2 class="h3">Cookievoorkeuren</h2>
    <p>
      {{ brandName }} gebruikt functionele, analytische en tracking cookies om
      je gebruikerservaring te verbeteren. Zo kunnen we je zo goed mogelijk
      helpen met al je energiezaken.
    </p>
    <h3 class="h5">Wij plaatsen altijd functionele en analytische cookies</h3>
    <p>
      Deze cookies zorgen voor een goed werkende website en maken een anonieme
      analyse van gebruikersgedrag.
    </p>
    <h3 class="h5">Na toestemming plaatsen wij tracking cookies</h3>
    <p>
      Deze cookies zorgen voor een persoonlijke en relevante gebruikerservaring
      op onze eigen website, andere websites en social media. Zo zie je voor jou
      gepersonaliseerde advertenties en inhoud. En vragen we je persoonlijke
      gebruikerservaring uit om onze online diensten te verbeteren.
    </p>
    <h3 class="h5">Jij bepaalt wat je met ons wilt delen</h3>
    <p>
      Als je op ‘cookies accepteren’ klikt, ga je akkoord met alle cookies. Klik
      je op ‘cookies weigeren’, dan plaatsen we alleen de functionele en
      analytische cookies.
      <a href="/cookies"
        >Via cookie-instellingen kun je op ieder moment je keuze wijzigen of je
        toestemming intrekken</a
      >.
    </p>
    <p>
      Lees meer in onze <a href="/privacyverklaring">privacyverklaring</a> en
      <a href="/cookies">cookieverklaring.</a>
    </p>
  </div>
</div>
<div class="p-2 modal-footer d-flex justify-content-start">
  <div class="d-flex gap-2 flex-column flex-md-row flex-grow-1">
    <crnt-button
      class="modal__button"
      wlAutomationId="cookiewall-accept"
      tabindex="0"
      (click)="accept()"
    >
      Cookies accepteren
    </crnt-button>
    <crnt-button
      class="modal__button"
      wlAutomationId="cookiewall-reject"
      tabindex="0"
      (click)="reject()"
    >
      Cookies weigeren
    </crnt-button>
  </div>
</div>
